import numbersHelper from "../../helpers/numbers.helper";

// Calculate Total Price (without VAT)
export const calculateTotalPrice = (cartItemList) => {
  const totalCalculatedPrice = cartItemList.reduce((total, item) => {
    return total + item.quantity * item.salePriceInNIS;
  }, 0);
  return numbersHelper.formatToTwoDecimalPlaces(totalCalculatedPrice);
};

// Calculate VAT Price
export const calculateVatPrice = (totalPrice, vatPercent) => {
  return numbersHelper.formatToTwoDecimalPlaces((totalPrice * vatPercent) / 100);
};

// Calculate Total Price with VAT
export const calculateTotalPriceWithVat = (cartItemList, vatPercent) => {
  const totalPrice = calculateTotalPrice(cartItemList);
  const vatPrice = calculateVatPrice(totalPrice, vatPercent);
  return numbersHelper.formatToTwoDecimalPlaces(+totalPrice + +vatPrice);
};

const shoppingCartService = {
  calculateTotalPrice,
  calculateVatPrice,
  calculateTotalPriceWithVat,
};

export default shoppingCartService;
